interface CircleLoaderProps {
  size?: number;
  strokeWidth?: number;
  color?: string;
}

const CircleLoader = ({ size = 50, strokeWidth = 4, color = '#007bff' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 50 50"
      style={{ animation: 'rotate 2s linear infinite' }}
    >
      <circle
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        style={{
          strokeDasharray: '80, 200',
          strokeDashoffset: 0,
          animation: 'dash 1.5s ease-in-out infinite',
        }}
      />
      <style jsx>{`
        @keyframes rotate {
          100% {
            transform: rotate(360deg);
          }
        }
        @keyframes dash {
          0% {
            stroke-dasharray: 1, 200;
            stroke-dashoffset: 0;
          }
          50% {
            stroke-dasharray: 89, 200;
            stroke-dashoffset: -35px;
          }
          100% {
            stroke-dasharray: 89, 200;
            stroke-dashoffset: -124px;
          }
        }
      `}</style>
    </svg>
  );
};

export default CircleLoader;
